import React  from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ConversationView } from './components/ConversationView'
import { ConversationMembersModal } from './components/ConversationMembersModal'
import { MessageInput } from './components/MessageInput'
import { fetchCurrentConversationMessages } from '../../actions/currentConversation/fetchCurrentConversationMessages'
import { fetchCurrentConversationMoreMessages } from '../../actions/currentConversation/fetchMoreConversationData'
import { markCurrentConversationAsRead } from '../../actions/currentConversation/markCurrentConversationAsRead'

export const CurrentConversationView = ({ currentConversation }) => {
  const dispatch = useDispatch()
  const { conversations } = useSelector(state=>state)
  const [ showModal, setShowModal ] = React.useState(false)

  React.useEffect(()=>{
    if (currentConversation.id) {
      dispatch(fetchCurrentConversationMessages(currentConversation, false))
      dispatch(markCurrentConversationAsRead())
    }
  },[conversations])

  return(
    <>
      <ConversationMembersModal show={showModal} handleClose={()=>setShowModal(false)} recipients={currentConversation.recipients} conversation={currentConversation}/>
      <div className="w-100 border-left h-100 d-flex flex-column">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div>{ !!currentConversation.group_id ? currentConversation.subject : currentConversation.title }</div>
          <div onClick={()=>setShowModal(true)} className="fas fa-info-circle text-primary d-flex align-items-center" style={{ fontSize: 16, height: '26px' }}/>
        </div>
        <ConversationView
          isReadOnly={currentConversation.is_read_only}
          loadingMoreMessages={currentConversation.loadingMoreMessages}
          loading={currentConversation.loading}
          messages={currentConversation.messages}
          scrollPosition={currentConversation.scrollPosition}
          loadMore={(scrollPosition) => {
            if(currentConversation.canLoadMoreMessages) {
                dispatch(fetchCurrentConversationMoreMessages(currentConversation, 
                      {showLoading: true, scrollPosition: scrollPosition}))
              }
            }
          }
          />
        <MessageInput/>
      </div>
    </>
  )
}